import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { BlueArrowDown } from "../../assets/InterBranch/SVGIcons/icons";
import {
  getCountryArray,
  getCountryDetailsByCountryCode,
} from "../../constants/country";
import { getCountryCode } from "../../actions/UtiliAction";
import CountryList from "./CountryList";
import "./phoneinputv2.css";

function CustomPhoneInputV2({
  placeholder,
  onChange,
  name,
  defaultvalue,
  defaultCountryCode,
  theme,
  disabled,
  onBlur,
  value,
  css,
}) {
  
  
  const dispatch = useDispatch();
  let [countryArray, setCountryArray] = useState(getCountryArray());
  let [isListOpen, setListOpen] = useState(false);
  let [number, setNumber] = useState();
  const [mobilecode, setmobilecode] = useState("");
  const [accessCountry, setaccessCountry] = useState("");
  let [countycode, Setcountrcode] = useState(
    sanitizeCountryCode(defaultCountryCode)
  );
  let listRef = useRef();
  let inputRef = useRef();

  console.log(defaultCountryCode,defaultvalue,value)
 



let [selecedCountry, selectCountry] = useState({
  name: "India",
  flag: "🇮🇳",
  code: "IN",
  dial_code: '+91',
});

  useEffect(() => {
    setNumber(defaultvalue);
    loadDefaultCountry()
  }, []);

  useEffect(() => {
    setNumber(value);
    // loadDefaultCountry();
  }, [value]);

  useEffect(() => {
    loadDefaultCountry();
  }, [defaultCountryCode]);

  const loadDefaultCountry = async () => {
    if (countycode.length > 0) {
      const sel = await getCountryDetailsByCountryCode(
        sanitizeCountryCode(defaultCountryCode)
      );

      selectCountry(sel);
    } else {
      console.log("sel else");
    }
  };

  useEffect(() => {
    dispatch(getCountryCode()).then((res)=>{
      console.log("res",res)
      setmobilecode(sanitizeCountryCode(res.countryCode));
      setaccessCountry(res.Country);
    })
}, [])

console.log("mobilecode",mobilecode)

  function handleCountryCodeSelect(e, value) {
    selectCountry(value);
    setListOpen(!isListOpen);

    let data = {
      name: value?.name,
      dialCode: value?.dial_code?.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ""),
      countryCode: value?.code,
      number,
    };

    onChange(
      number,
      `${selecedCountry?.dial_code?.replace(
        /[&\/\\#,+()$~%.'":*?<>{}]/g,
        ""
      )} ${number}`,
      data,
      inputRef.current
    );
  }

  let handleInputChange = (e) => {
    setNumber(e.target.value);

    let value = e.target.value;

    let data = {
      name: selecedCountry?.name,
      dialCode: selecedCountry?.dial_code?.replace("+", ""),
      countryCode: selecedCountry?.code,
      number: value,
    };

    onChange(
      value,
      `${selecedCountry?.dial_code?.replace(
        /[&\/\\#,+()$~%.'":*?<>{}]/g,
        ""
      )} ${value}`,
      data,
      e
    );
  };

  function allowOnlyNumericsOrDigits(e) {
    !["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace"].includes(
      e.key
    ) && e.preventDefault();
  }

  const getTheme = (theme) => {
    switch (theme) {
      case "signin":
        return "phone-input-v2-container-signin";
      case "white-theme":
        return "phone-input-v2-container-white";

      default:
        break;
    }
  };

  function sanitizeCountryCode(code) {
    return code ? (code.indexOf("+") >= 0 ? code : `+${code}`) : "+91";
  }

  return (
    <div
    style={css}
      className={`phone-input-v2-container ${getTheme(theme)} ${
        disabled && "phone-input-v2-container-disabled"
      }`}
    >
      <div
        className= {disabled ? "country-code-container-disabled" : "country-code-container"}
        onClick={() => {
          !disabled && setListOpen(!isListOpen);
        }}
      >
        {/* <img className='flag-image' src={`https://countryflagsapi.com/png/${selecedCountry ? selecedCountry.code : "india"}`} alt="" /> */}
        <img
          className="flag-image"
          src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${
            selecedCountry ? selecedCountry.code : "IN"
          }.svg`}
          alt=""
        />

        <span className="country-code-text">{selecedCountry?.dial_code}</span>

        <BlueArrowDown />

        {isListOpen && (
          <CountryList
            setOpen={setListOpen}
            isListOpen={isListOpen}
            ref={listRef}
            countryArray={countryArray}
            onClick={handleCountryCodeSelect}
          />
        )}
      </div>

      <div className="phone-input-v2-divider"></div>

      <input
        disabled={disabled}
        onBlur={onBlur ? onBlur : () => {}}
        ref={inputRef}
        maxLength={12}
        name={name}
        value={number}
        // onKeyDown={(e) => {
        //   e.key === "Enter" ? e.preventDefault() : allowOnlyNumericsOrDigits(e);
        // }}
        onKeyPress={(e) => {
          const englishRegex = /^[0-9\s]*$/;
          if (!englishRegex.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
            e.preventDefault();
          }
        }}
        onPaste={(e) => {
          const pastedData = e.clipboardData.getData('text/plain');
          const englishRegex = /^[0-9\s]*$/;
          if (!englishRegex.test(pastedData)) {
            e.preventDefault();
          }
        }}
        onChange={handleInputChange}
        placeholder={placeholder}
        className={disabled ? "mobile-number-input-disabled" : "mobile-number-input"}
        type="tel"
        autoComplete="off"
      />
    </div>
  );
}

export default CustomPhoneInputV2;
